import { usePaymentPresentationLocale } from '../lib/usePaymentPresentationLocale'
import React from 'react'
import { CheckCircle2, CreditCard, ShieldCheck, XCircle } from 'lucide-react'
import { Link, useSearchParams } from 'react-router-dom'

const CONFIG = {
  received: {
    icon: CheckCircle2,
    eyebrow: "portalPresentation.member_payment_received",
    title: "portalPresentation.member_thank_you_your_payment_is_processing",
    body: "portalPresentation.member_your_secure_checkout_has_completed_we_ll_update_your_account_as_soon_as_the_club_s_payment_confirmation_is_received",
    tone: 'success',
  },
  cancelled: {
    icon: CreditCard,
    eyebrow: "facilityBooking.checkoutCancelled",
    title: "portalPresentation.member_no_payment_was_taken",
    body: "portalPresentation.member_you_can_return_to_your_account_and_start_secure_checkout_again_whenever_you_are_ready",
    tone: 'neutral',
  },
  declined: {
    icon: XCircle,
    eyebrow: "portalPresentation.member_payment_declined",
    title: "portalPresentation.member_your_payment_could_not_be_completed",
    body: "portalPresentation.member_checkout_normally_shows_card_decline_messages_before_redirecting_this_page_is_here_if_the_club_sends_you_a_manual_declined_payment_link",
    tone: 'warning',
  },
}

export default function MemberPrivanaPayResultPage({ clubCode = '', state = 'received' }) {
  const { t, locale } = usePaymentPresentationLocale(false)
  const [searchParams] = useSearchParams()
  const resolvedClubCode = clubCode || searchParams.get('club') || ''
  const config = CONFIG[state] || CONFIG.received
  const Icon = config.icon
  const accountPath = resolvedClubCode ? `/${resolvedClubCode}/account` : '/login'

  return (
    <div className={`mp-payment-result mp-payment-result--${config.tone}`} lang={locale}>
      <div className="mp-payment-result__card">
        <div className="mp-payment-result__icon"><Icon size={34} /></div>
        <p className="mp-eyebrow">{t(config.eyebrow)}</p>
        <h1>{t(config.title)}</h1>
        <p>{t(config.body)}</p>
        {state === 'received' ? (
          <div className="mp-payment-result__secure"><ShieldCheck size={18} /> {t("portalPresentation.member_secure_checkout_completed_in_stripe")} </div>
        ) : null}
        <div className="mp-payment-result__actions">
          <Link className="mp-primary" to={accountPath}> {t("portalPresentation.member_return_to_account")} </Link>
        </div>
      </div>
    </div>
  )
}
